import React from 'react';
import { MultiSelectDropdown } from './dropdown/multi-select-dropdown';
import { Dropdown } from './dropdown/select-dropdown';
import { Menu } from './menu/select-menu';

type SelectType = React.FC & {
  Menu: typeof Menu;
  Dropdown: typeof Dropdown;
  MultiSelectDropdown: typeof MultiSelectDropdown;
};

export const Select: SelectType = () => null;
Select.Menu = Menu;
Select.Dropdown = Dropdown;
Select.MultiSelectDropdown = MultiSelectDropdown;
